<template>
  <section id="collection-enquiry">
    <router-link id="link_collection-enquiry_not-collected" v-if="isNotInNetwork() || this.getTrackingOverride()" to="/collection-enquiry/not-collected">Parcel not collected</router-link>
    <router-link id="link_collection-enquiry_provide-instructions" v-if="isNotInNetwork() || this.getTrackingOverride()" to="/collection-enquiry/provide-instructions">Provide Collection instructions to my Courier</router-link>
    <router-link id="link_collection-enquiry_cancel-collection" v-if="isNotInNetwork() || this.getTrackingOverride()" :to="this.$store.state.businessAccount ? '/collection-enquiry/cancel-collection-ba' : '/collection-enquiry/cancel-collection'">I want to cancel the collection</router-link>
    <router-link id="link_collection-enquiry_book-collection" v-if="isNotInNetwork() || this.getTrackingOverride()" to="/collection-enquiry/book-collection">Book a collection</router-link>
    <router-link id="link_collection-enquiry_return-not-received" v-if="isReturnNotReceived() || this.getTrackingOverride()" to="/collection-enquiry/return-not-received">Return not received by client</router-link>
    <router-link id="link_collection-enquiry_critical" v-if="isStage('1') && !this.isReturnBarcode()" to="/collection-enquiry/critical">I need to report a critical issue</router-link>
    <router-view></router-view>
  </section>
</template>

<script>
import { mapState } from "vuex";
import trackingJS from '../helpers/tracking.js';

export default {
  mixins: [trackingJS],
  computed: {
    ...mapState({
      tracking: state => state.tracking
    })
  },
  methods: {
    isNotInNetwork() { return (this.isStage('1') || (this.isStage('6') && (this.$store.state.tracking.barcode.charAt(5) == 'D' || this.$store.state.tracking.barcode.charAt(5) == 'E' || this.$store.state.tracking.barcode.substring(0,2) == '34')))} ,
    isReturnNotReceived() { return this.isStage('5', '6') },
    isStage(...stages) {
      return stages.indexOf(this.tracking.stage) !== -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sections/CollectionEnquiry.vue